import { SENDFACTOR_FETCH_REQUEST, SENDFACTOR_FETCH_SUCCESS, SENDFACTOR_FETCH_FAILURE } from './types';

const initialState = {
    loading: false,
    factor: {},
    error: ''
}

const factor = (state = initialState, action) => {
    switch (action.type) {
        case SENDFACTOR_FETCH_REQUEST:
            return {
                loading: true,
                factor: {},
                error: '',
            }
        case SENDFACTOR_FETCH_SUCCESS:
            return {
                loading: false,
                factor: action.payload,
                error: ''
            }
        case SENDFACTOR_FETCH_FAILURE:
            return {
                loading: false,
                factor: {},
                error: action.payload
            }
        default:
            return state
    }
}

export default factor;